import React from 'react';

import { useModalContext } from './ModalContext';

const getChildFlex = (flex, key) =>
  Array.isArray(flex) && flex.length !== 1 ? flex[key] || flex[0] : flex;

const wrappedChildren = (children, flex = '0 1 auto') => {
  if (!Array.isArray(children)) return children;
  return React.Children.map(children, (child, key) => {
    if (child) {
      return (
        <div flex={getChildFlex(flex, key)}>
          {React.cloneElement(child, {
            ref: child.ref
              ? (node) => {
                  // Call the original ref, if any
                  const { ref } = child;
                  if (typeof ref === 'function') {
                    ref(node);
                  } else if (ref !== null) {
                    ref.current = node;
                  }
                }
              : null,
          })}
        </div>
      );
    }
    return null;
  });
};

const ModalFooter = ({ dataTest, children, flex }) => {
  const { isMobileFullPage } = useModalContext();
  return (
    <div data-test={dataTest} isMobileFullPage={isMobileFullPage}>
      {wrappedChildren(children, flex)}
    </div>
  );
};

export default ModalFooter;
